// extracted by mini-css-extract-plugin
export default {"centerLoader":"Page_centerLoader__wSUM5","placeholderText":"Page_placeholderText__80pPU","profileCompletionBox":"Page_profileCompletionBox__0GhNg"};